import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.74 9.562h-2.49c-1.867 0-2.812-1.057-2.812-3.15V4.26c0-.765.09-1.86.884-2.46.668-.495 1.628-.533 3.046-.12 1.86.54 3.412 2.092 3.952 3.952.413 1.41.375 2.378-.12 3.038-.6.802-1.695.892-2.46.892M10.71 2.52c-.308 0-.548.06-.705.18-.293.217-.435.727-.435 1.56v2.16c0 1.68.645 2.025 1.688 2.025h2.49c.825 0 1.335-.143 1.56-.435.262-.345.24-1.035-.053-2.048-.435-1.477-1.71-2.76-3.187-3.187-.556-.173-1.005-.255-1.358-.255"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.303 17.063q-.599.002-1.208-.098c-3.067-.495-5.565-2.985-6.06-6.052-.637-3.945 1.905-7.665 5.798-8.46a.57.57 0 0 1 .667.435.57.57 0 0 1-.435.667C3.773 4.23 1.613 7.38 2.16 10.733c.42 2.595 2.528 4.702 5.123 5.122 3.367.54 6.51-1.627 7.177-4.935a.562.562 0 1 1 1.103.218 7.39 7.39 0 0 1-7.26 5.925"
    }, null, -1)
  ]))]))
}
export default { render: render }